import { coreApi } from '$api'
import { PayClassification, transformPayClassificationOnGet } from '$models'

/**
 * Activate a Pay Classification for the current venue (creates/extends its activation record).
 * @param payClassificationId the Pay Classification to activate
 * @returns the updated Pay Classification (now carrying its activation)
 */
export const activate = async (
  payClassificationId: string
): Promise<PayClassification> => {
  const response = await coreApi.activatePayClassification(payClassificationId)
  return transformPayClassificationOnGet(response)
}

/**
 * Deactivate a Pay Classification for the current venue (unassign the venue from its activation).
 * @param payClassificationId the Pay Classification to deactivate
 * @returns the updated Pay Classification (its activation now soft-deleted)
 */
export const deactivate = async (
  payClassificationId: string
): Promise<PayClassification> => {
  const response = await coreApi.deactivatePayClassification(
    payClassificationId
  )
  return transformPayClassificationOnGet(response)
}
